// The published MyAdvisorRetirement legal texts (RB-326, 10-19-26): the app links and frames the product host's pages instead of
// carrying its own copy, so one text serves the site, the app and the sign-up acceptance. The version strings are the ones the
// published pages print; bump them here IN THE SAME CHANGE that publishes a new version on the product host (the host deploys first, then this), or the label names a
// version the framed page no longer shows (the host serves the current text only; there is no versioned URL).
export const LEGAL = {
    productName: 'MyAdvisorRetirement',
    host: 'myadvisorretirement.ai',
    termsUrl: 'https://myadvisorretirement.ai/terms',
    privacyUrl: 'https://myadvisorretirement.ai/privacy',
    agreementVersion: '2026-10-21.1',
    privacyVersion: '2026-10-21.1',
} as const;

// the sentence the sign-up checkbox carries: the product name, the agreement, its version, where it is published, and the
// three sections the agreement's Section V.ii says the Producer confirms having read (the one control names them; the
// agreement's wording matches this control, legal-brand-15 10-21-26)
export const agreementAcceptanceText = (): string =>
    `I agree to the ${LEGAL.productName} User Agreement, version ${LEGAL.agreementVersion}, published at ${LEGAL.host}/terms, and I have read its Sections I.i (the production requirement), III.i (the non-compete) and III.iii (remedies)`;
